export default __webpack_public_path__ + "static/media/download.4bced338.svg";